import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=74cecad6&"
import script from "./PromotionsList.vue?vue&type=script&lang=js&"
export * from "./PromotionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cecad6')) {
      api.createRecord('74cecad6', component.options)
    } else {
      api.reload('74cecad6', component.options)
    }
    module.hot.accept("./PromotionsList.vue?vue&type=template&id=74cecad6&", function () {
      api.rerender('74cecad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/PromotionsList.vue"
export default component.exports